import apiTamboUrl from "@/services/api";

export default {
  namespaced: true,
  state: {
    tambos: [],
    loading: false,
    error: null,
  },
  getters: {
    tambos(state) {
      return state.tambos;
    },
    loading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
    canCreateTambo(state) {
      return state.tambos.some((t) => t.mi_rol === "duenio");
    },
    tamboActual(state, getters, rootState) {
      const tamboId = rootState.userTamboStore?.currentTamboId;
      if (!tamboId) return null;
      return state.tambos.find((t) => t.id == tamboId) || null;
    },
  },
  mutations: {
    setTambos(state, tambos) {
      state.tambos = tambos;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setError(state, error) {
      state.error = error;
    },
    setTipoSistemaTambo(state, { tamboId, tipo_sistema }) {
      const idx = (state.tambos || []).findIndex((t) => t.id == tamboId);
      if (idx !== -1) {
        state.tambos[idx].tipo_sistema = tipo_sistema;
      }
    },
  },
  actions: {
    async fetchTamboActual({ dispatch, getters }, { force = false } = {}) {
      if (force || !getters.tambos || getters.tambos.length === 0) {
        await dispatch("getTambos");
      }
      return getters.tamboActual;
    },

    async getTambos({ commit }) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const response = await apiTamboUrl.get("/mis-tambos/");
        if (response.status === 200 || response.status === 201) {
          console.log("📋 Tambos obtenidos del backend:", response.data);
          commit("setTambos", response.data);
        }
      } catch (error) {
        console.error("Error al obtener los tambos:", error);
        commit("setError", error.message || "Error al obtener los tambos");
      } finally {
        commit("setLoading", false);
      }
    },

    async postTambo({ commit, dispatch }, payload) {
      try {
        const response = await apiTamboUrl.post("/tambos/", payload);
        if (response.status === 200 || response.status === 201) {
          await dispatch("getTambos");
        }
        return response;
      } catch (error) {
        console.error("Error al crear el tambo:", error);
        const errorMsg =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          error.message ||
          "Error al crear el tambo";
        commit("setError", errorMsg);
        throw error;
      }
    },

    async patchTambo({ commit, dispatch }, { tamboId, payload }) {
      try {
        const response = await apiTamboUrl.patch(
          `/tambos/${tamboId}/`,
          payload
        );
        if (response.status === 200 || response.status === 201) {
          await dispatch("getTambos");
        }
        return response;
      } catch (error) {
        console.error("Error al actualizar el tambo:", error);
        const errorMsg =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          error.message ||
          "Error al actualizar el tambo";
        commit("setError", errorMsg);
        throw error;
      }
    },

    async patchTipoSistema({ commit, dispatch }, { tamboId, tipo_sistema }) {
      try {
        const response = await apiTamboUrl.patch(`/tambos/${tamboId}/`, {
          tipo_sistema,
        });
        if (response.status === 200 || response.status === 201) {
          commit("setTipoSistemaTambo", { tamboId, tipo_sistema });
          await dispatch("getTambos");
        }
        return response;
      } catch (error) {
        console.error("Error al actualizar tipo de sistema del tambo:", error);
        const errorMsg =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          error.message ||
          "Error al actualizar la configuración del tambo";
        commit("setError", errorMsg);
        throw error;
      }
    },

    async fetchTamboById({ commit }, tamboId) {
      try {
        const response = await apiTamboUrl.get(`/tambos/${tamboId}/`);
        return response.data;
      } catch (error) {
        console.warn(`Error al obtener tambo ${tamboId}:`, error);
        throw error;
      }
    },

    // ✅ MEJORADO: Usar la acción centralizada de cambio de tambo
    async selectTambo(
      { dispatch },
      { tamboId, tamboName, tipoSistema, modoProduccion }
    ) {
      console.log(
        `Seleccionando tambo: ${tamboName} (ID: ${tamboId}) - Modo: ${modoProduccion}`
      );

      try {
        // Usar la acción del userTamboStore que maneja todo el cambio
        const success = await dispatch(
          "userTamboStore/changeTambo",
          { tamboId, tamboName, tipoSistema, modoProduccion },
          { root: true }
        );

        if (success) {
          return { status: 200 };
        } else {
          throw new Error("Error al cambiar de tambo");
        }
      } catch (error) {
        console.error("Error al seleccionar el tambo:", error);
        throw error;
      }
    },
  },
};
